<div class="viewjob-hero">
  <app-breadcrumbs></app-breadcrumbs>
  <!-- Decorative orbs and wave to match the Apple-like hero -->
  <svg class="hero-orb orb-a" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
    <defs>
      <radialGradient id="directApplyOrbGradientA" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#75b6e7" stop-opacity="0.6"/>
        <stop offset="100%" stop-color="#75b6e7" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#directApplyOrbGradientA)"/>
  </svg>
  <svg class="hero-orb orb-b" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
    <defs>
      <radialGradient id="directApplyOrbGradientB" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#ffffff" stop-opacity="0.35"/>
        <stop offset="100%" stop-color="#ffffff" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#directApplyOrbGradientB)"/>
  </svg>
  <svg class="hero-wave" viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true" focusable="false">
    <path d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z" fill="#f6f6f6"></path>
  </svg>
</div>
<div class="title-container-1">
  <div class="title-container-2">
    <div class="search-text"></div>
  </div>
</div>
@if (!isLoadingJob) {
  <div #viewJobRef class="view-job" [formGroup]="form">
    <div class="job-container">
      <div class="vacancies">
        <div #vacancyRef class="vacancy" [class.applied-state]="applied">
          @if (applied) {
            <div class="applied">
              <div class="applied-header">
                Sollicitatie ontvangen!
              </div>
              <div class="applied-paragraph">
                Je sollicitatie is successvol ontvangen. Wij zullen binnenkort contact met je opnemen.
              </div>
              <div>
                <button class="apple-cta apple-cta--blue" (click)="navigateTo('home')">
                  <span>We gaan vanzelf terug in &nbsp;<span class="countdown ml-1">{{countdown}}</span>s</span>
                  <icon name="navigate_next"></icon>
                </button>
              </div>
            </div>
          }
          @if (!applied) {
            <div class="vacancy-header">{{job.title}}</div>
            <div class="vacancy-filter-container">
              <div class="vacancy-filter-left">
                <div class="vacancy-filter-row">
                  <icon name="location_on_filled"></icon>
                  <div class="vacancy-filter-row-container">
                    <span>Locatie</span>
                    <span class="vacancy-type">{{job.location.city}}</span>
                  </div>
                </div>
                <div class="vacancy-filter-row">
                  <icon name="business"></icon>
                  <div class="vacancy-filter-row-container">
                    <span>Functiegebieden</span>
                    <div class="vacancy-type">{{mapIndustries(job)}}</div>
                  </div>
                </div>
                <div class="vacancy-filter-row">
                  <icon name="school_filled"></icon>
                  <div class="vacancy-filter-row-container">
                    <span>Opleidingsniveau</span>
                    <span class="vacancy-type">{{job.education}}</span>
                  </div>
                </div>
              </div>
              <div class="vacancy-filter-right">
                <div class="vacancy-filter-row">
                  <icon name="euro"></icon>
                  <div class="vacancy-filter-row-container">
                    <span>Salaris</span>
                    <span class="vacancy-type">{{parseSalary(job.salary)}}</span>
                  </div>
                </div>
                <div class="vacancy-filter-row">
                  <icon name="schedule_filled"></icon>
                  <div class="vacancy-filter-row-container">
                    <span>Dienstverband</span>
                    <span class="vacancy-type">{{job.employment}}</span>
                  </div>
                </div>
                <div class="vacancy-filter-row">
                  <icon name="hourglass_filled"></icon>
                  <div class="vacancy-filter-row-container">
                    <span>Uren</span>
                    <span class="vacancy-type">{{parseHours(job)}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="vacancy-description">
              <mat-error #resumeErrorRef class="resume-error hidden">Upload een CV.</mat-error>
              <div class="upload-files">
                <div #resumeRef class="resume" [ngClass]="{ 'is-drag-over': dropResume }">
                  <div class="resume-upload">
                    @if (resume) {
                      <div class="resume-uploaded">
                        <div class="resume-files" (click)="deleteResume($event)">
                          <icon name="file"></icon>
                          <div class="resume-files-text">{{ resume.name }}</div>
                        </div>
                      </div>
                    }
                    @if (!resume) {
                      @if (dropResume) {
                        <div class="resume-text">
                          Drop je CV hier!
                        </div>
                      }
                      @if (!dropResume) {
                        <input type="file" name="resume" id="resume" accept=".pdf,.doc,.docx" (change)="resumeChange($event)" multiple>
                        <label class="resume-button apple-cta apple-cta--blue" for="resume">
                          <div>Upload CV</div>
                          <icon name="file_upload"></icon>
                        </label>
                        @if (!isMobile) {
                          <div class="resume-text">of drop je bestand hier!</div>
                        }
                      }
                    }
                  </div>
                </div>
                <div #motivationLetterRef class="resume" [ngClass]="{ 'is-drag-over': dropMotivationLetter }">
                  <div class="resume-upload">
                    @if (motivationLetter) {
                      <div class="resume-uploaded">
                        <div class="resume-files" (click)="deleteMotivationLetter($event)">
                          <icon name="file"></icon>
                          <div class="resume-files-text">{{ motivationLetter.name }}</div>
                        </div>
                      </div>
                    }
                    @if (!motivationLetter) {
                      @if (dropMotivationLetter) {
                        <div class="resume-text">
                          Drop je motivatiebrief hier!
                        </div>
                      }
                      @if (!dropMotivationLetter) {
                        <input type="file" name="motivationLetter" id="motivationLetter" accept=".pdf,.doc,.docx"(change)="motivationLetterChange($event)" multiple>
                        <label class="resume-button apple-cta apple-cta--blue" for="motivationLetter">
                          <div>Upload motivatiebrief</div>
                          <icon name="file_upload"></icon>
                        </label>
                        @if (!isMobile) {
                          <div class="resume-text">of drop je bestand hier!</div>
                        }
                      }
                    }
                  </div>
                </div>
              </div>
              <div class="resume-types">
                Ondersteunde bestandstypen: .pdf, .doc, .docx (max. 10 MB)
              </div>
              <div class="apple-field-label">Voornaam</div>
              <div class="apple-input-container">
                <input class="apple-input" maxlength="50" type="text" placeholder="Voornaam" formControlName="firstName">
                @if (firstName) {
                  <button class="apple-clear-button" type="button" aria-label="Clear" (click)="clearFirstName()">
                    <icon name="close"></icon>
                  </button>
                }
              </div>
              @if (form.get('firstName')?.touched && form.get('firstName')?.hasError('required')) {
                <div class="apple-error">Voornaam is verplicht.</div>
              }
              <div class="apple-field-label">Achternaam</div>
              <div class="apple-input-container">
                <input class="apple-input" maxlength="50" type="text" placeholder="Achternaam" formControlName="lastName">
                @if (lastName) {
                  <button class="apple-clear-button" type="button" aria-label="Clear" (click)="clearLastName()">
                    <icon name="close"></icon>
                  </button>
                }
              </div>
              @if (form.get('lastName')?.touched && form.get('lastName')?.hasError('required')) {
                <div class="apple-error">Achternaam is verplicht.</div>
              }
              <div class="apple-field-label">E-mailadres</div>
              <div class="apple-input-container">
                <input class="apple-input" placeholder="bv. info@blauwtand.com" type="email" formControlName="email" [pattern]="emailPattern">
                @if (email) {
                  <button class="apple-clear-button" type="button" aria-label="Clear" (click)="clearEmail()">
                    <icon name="close"></icon>
                  </button>
                }
              </div>
              @if (form.get('email')?.touched && form.get('email')?.hasError('required')) {
                <div class="apple-error">E-mailadres is verplicht.</div>
              }
              @if (form.get('email')?.touched && form.get('email')?.hasError('email')) {
                <div class="apple-error">Vul een geldig e-mailadres in (bijv. info&#64;blauwtand.com).</div>
              }
              <div class="apple-field-label">Adres</div>
              <div class="apple-input-container">
                <input class="apple-input" maxlength="50" placeholder="bv. Goudenregenzoom 17" type="text" formControlName="address">
                @if (address) {
                  <button class="apple-clear-button" type="button" aria-label="Clear" (click)="clearAddress()">
                    <icon name="close"></icon>
                  </button>
                }
              </div>
              <div class="apple-field-label">Plaats</div>
              <div class="apple-input-container">
                <input class="apple-input" maxlength="50" placeholder="bv. Zoetermeer" type="text" formControlName="location">
                @if (location) {
                  <button class="apple-clear-button" type="button" aria-label="Clear" (click)="clearLocation()">
                    <icon name="close"></icon>
                  </button>
                }
              </div>
              <div class="apple-field-label">Postcode</div>
              <div class="apple-input-container">
                <input class="apple-input" placeholder="bv. 2719 HA" type="text" formControlName="postalCode" autocomplete="postal-code" toUppercase>
                @if (postalCode) {
                  <button class="apple-clear-button" type="button" aria-label="Clear" (click)="clearPostalCode()">
                    <icon name="close"></icon>
                  </button>
                }
              </div>
              @if (form.get('postalCode')?.touched && form.get('postalCode')?.invalid) {
                <div class="apple-error">{{ postalCodeError }}</div>
              }
              <div class="apple-field-label">Telefoonnummer</div>
              <div class="apple-input-container">
                <input class="apple-input" type="tel" inputmode="tel" autocomplete="tel" placeholder="Telefoonnummer" formControlName="phone">
                @if (phone) {
                  <button class="apple-clear-button" type="button" aria-label="Clear" (click)="clearPhone()">
                    <icon name="close"></icon>
                  </button>
                }
              </div>
              @if (form.get('phone')?.touched && form.get('phone')?.invalid) {
                <div class="apple-error">{{ phoneError }}</div>
              }
              <div class="privacy-checkbox-container" #checkboxContainerRef>
                <input #checkboxRef required type="checkbox" class="privacy-checkbox" [checked]="isPrivacyStatementChecked" (change)="changeCheckbox($event)">
                <div class="privacy-checkbox-text">Ja, ik heb gezien dat Blauwtand een <span class="privacy-statement" (click)="navigateTo('privacy-statement')">privacy statement</span> heeft. *</div>
              </div>
              <div class="vacancy-apply">
                <button [disabled]="isSendingApplication" class="vacancy-apply-button apple-cta apple-cta--blue" (click)="apply()">
                  <div>{{sendApplicationText}}</div>
                  @if (!isSendingApplication) {
                    <icon name="navigate_next"></icon>
                  }
                  @if (isSendingApplication) {
                    <mat-icon class="spinner-send">
                      <mat-spinner color="primary" diameter="20"></mat-spinner>
                    </mat-icon>
                  }
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (isLoadingJob) {
  <div #viewJobRef class="view-job" [formGroup]="form">
    <div class="job-container">
      <div class="vacancies">
        <div #vacancyRef class="vacancy">
          @if (!applied) {
            <!-- <div class="vacancy-header">{{job?.title}}</div> -->
            <div class="vacancy-header-skeleton skeleton-box"></div>
            <div class="vacancy-filter-container">
              <div class="vacancy-filter-left">
                <div class="vacancy-filter-row">
                  <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                  <div class="vacancy-filter-row-container">
                    <span class="vacancy-type-skeleton skeleton-box"></span>
                    <div class="margin-small-skeleton"></div>
                    <span class="vacancy-type-skeleton skeleton-box"></span>
                  </div>
                </div>
                <div class="vacancy-filter-row">
                  <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                  <div class="vacancy-filter-row-container">
                    <span class="vacancy-type-skeleton skeleton-box"></span>
                    <div class="margin-small-skeleton"></div>
                    <span class="vacancy-type-skeleton skeleton-box"></span>
                  </div>
                </div>
                <div class="vacancy-filter-row">
                  <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                  <div class="vacancy-filter-row-container">
                    <span class="vacancy-type-skeleton skeleton-box"></span>
                    <div class="margin-small-skeleton"></div>
                    <span class="vacancy-type-skeleton skeleton-box"></span>
                  </div>
                </div>
              </div>
              <div class="vacancy-filter-right">
                <div class="vacancy-filter-row">
                  <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                  <div class="vacancy-filter-row-container">
                    <span class="vacancy-type-skeleton skeleton-box"></span>
                    <div class="margin-small-skeleton"></div>
                    <span class="vacancy-type-skeleton skeleton-box"></span>
                  </div>
                </div>
                <div class="vacancy-filter-row">
                  <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                  <div class="vacancy-filter-row-container">
                    <span class="vacancy-type-skeleton skeleton-box"></span>
                    <div class="margin-small-skeleton"></div>
                    <span class="vacancy-type-skeleton skeleton-box"></span>
                  </div>
                </div>
                <div class="vacancy-filter-row">
                  <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                  <div class="vacancy-filter-row-container">
                    <span class="vacancy-type-skeleton skeleton-box"></span>
                    <div class="margin-small-skeleton"></div>
                    <span class="vacancy-type-skeleton skeleton-box"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="vacancy-description">
              <mat-error #resumeErrorRef class="resume-error hidden">Upload een CV.</mat-error>
              <div class="upload-files">
                <div #resumeRef class="resume">
                  <div class="resume-upload">
                    @if (resume) {
                      <div class="resume-uploaded">
                        <div class="resume-files" (click)="deleteResume($event)">
                          <icon name="file"></icon>
                          <div class="resume-files-text">{{ resume.name }}</div>
                        </div>
                      </div>
                    }
                    @if (!resume) {
                      @if (dropResume) {
                        <div class="resume-text">
                          Drop je CV hier!
                        </div>
                      }
                      @if (!dropResume) {
                        <input type="file" name="resume" id="resume" accept=".pdf,.doc,.docx"(change)="resumeChange($event)" multiple>
                        <label class="resume-input" for="resume">
                          <button class="resume-button apple-cta apple-cta--blue" type="button">
                            <div>Upload CV</div>
                            <icon name="file_upload"></icon>
                          </button>
                        </label>
                        @if (!isMobile) {
                          <div class="resume-text">of drop je bestand hier!</div>
                        }
                      }
                    }
                  </div>
                </div>
                <div #motivationLetterRef class="resume">
                  <div class="resume-upload">
                    @if (motivationLetter) {
                      <div class="resume-uploaded">
                        <div class="resume-files" (click)="deleteMotivationLetter($event)">
                          <icon name="file"></icon>
                          <div class="resume-files-text">{{ motivationLetter.name }}</div>
                        </div>
                      </div>
                    }
                    @if (!motivationLetter) {
                      @if (dropMotivationLetter) {
                        <div class="resume-text">
                          Drop je motivatiebrief hier!
                        </div>
                      }
                      @if (!dropMotivationLetter) {
                        <input type="file" name="motivationLetter" id="motivationLetter" accept=".pdf,.doc,.docx"(change)="motivationLetterChange($event)" multiple>
                        <label class="resume-button apple-cta apple-cta--blue" for="motivationLetter">
                          <div>Upload motivatiebrief</div>
                          <icon name="file_upload"></icon>
                        </label>
                        @if (!isMobile) {
                          <div class="resume-text">of drop je bestand hier!</div>
                        }
                      }
                    }
                  </div>
                </div>
              </div>
              <div class="resume-types">
                Ondersteunde bestandstypen: .pdf, .doc, .docx (max. 10 MB)
              </div>
              <mat-form-field class="direct-apply-input-field" appearance="fill" >
                <mat-label>Voornaam</mat-label>
                <input matInput maxlength="50" type="text" formControlName="firstName">
                @if (firstName) {
                  <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFirstName()">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
              <mat-form-field class="direct-apply-input-field" appearance="fill" >
                <mat-label>Achternaam</mat-label>
                <input matInput maxlength="50" type="text" formControlName="lastName">
                @if (lastName) {
                  <button matSuffix mat-icon-button aria-label="Clear" (click)="clearLastName()">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
              <mat-form-field class="direct-apply-input-field" appearance="fill" >
                <mat-label>Emailadres</mat-label>
                <input matInput placeholder="bv. info@blauwtand.com" type="text" formControlName="email" [pattern]="emailPattern">
                @if (email) {
                  <button matSuffix mat-icon-button aria-label="Clear" (click)="clearEmail()">
                    <mat-icon>close</mat-icon>
                  </button>
                }
                @if (this.form.get('phone')?.invalid) {
                  <mat-error>Vul een geldig emailadres in. Bijvoorbeeld: info&#64;blauwtand.com.</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="direct-apply-input-field" appearance="fill" >
                <mat-label>Adres</mat-label>
                <input matInput maxlength="50" placeholder="bv. Goudenregenzoom 17" type="text" formControlName="address">
                @if (address) {
                  <button matSuffix mat-icon-button aria-label="Clear" (click)="clearAddress()">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
              <mat-form-field class="direct-apply-input-field" appearance="fill" >
                <mat-label>Plaats</mat-label>
                <input matInput maxlength="50" placeholder="bv. Zoetermeer" type="text" formControlName="location">
                @if (location) {
                  <button matSuffix mat-icon-button aria-label="Clear" (click)="clearLocation()">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
              <mat-form-field class="direct-apply-input-field" appearance="fill" >
                <mat-label>Postcode</mat-label>
                <input matInput placeholder="bv. 2719 HA" type="text" formControlName="postalCode" autocomplete="postal-code" toUppercase>
                @if (postalCode) {
                  <button matSuffix mat-icon-button aria-label="Clear" (click)="clearPostalCode()">
                    <mat-icon>close</mat-icon>
                  </button>
                }
                @if (this.form.get('postalCode')?.invalid) {
                  <mat-error>{{ postalCodeError }}</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="direct-apply-input-field" appearance="fill" >
                <mat-label>Telefoonnummer</mat-label>
                <input matInput type="tel" inputmode="tel" autocomplete="tel" formControlName="phone">
                @if (phone) {
                  <button matSuffix mat-icon-button aria-label="Clear" (click)="clearPhone()">
                    <mat-icon>close</mat-icon>
                  </button>
                }
                @if (this.form.get('phone')?.invalid) {
                  <mat-error>{{ phoneError }}</mat-error>
                }
              </mat-form-field>
              <div class="privacy-checkbox-container">
                <mat-checkbox #checkboxErrorRef required class="privacy-checkbox" color="primary" (change)="changeCheckbox($event)"></mat-checkbox>
                <div class="privacy-checkbox-text">Ja, ik heb gezien dat Blauwtand een <span class="privacy-statement" (click)="navigateTo('privacy-statement')">privacy statement</span> heeft. *</div>
              </div>
              <div class="vacancy-apply">
                <button [disabled]="isSendingApplication" class="vacancy-apply-button apple-cta apple-cta--blue" (click)="apply()">
                  <div>{{sendApplicationText}}</div>
                  @if (!isSendingApplication) {
                    <icon name="navigate_next"></icon>
                  }
                  @if (isSendingApplication) {
                    <mat-icon class="spinner-send">
                      <mat-spinner color="primary" diameter="20"></mat-spinner>
                    </mat-icon>
                  }
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
